var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "SBRenewalPopup",
        role: "dialog",
        "data-backdrop": "static",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header cancelModal-bgcolor" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: { click: _vm.closePopup },
                },
                [_vm._v("×")]
              ),
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Renewal Request"),
              ]),
              _c("hr", { staticClass: "m-0" }),
            ]),
            _c(
              "div",
              { staticClass: "modal-body row m-0" },
              [
                _vm.body_text === "default"
                  ? [
                      _c(
                        "p",
                        {
                          staticClass: "col-xs-12 service-name text-color-blue",
                        },
                        [_vm._v(_vm._s(_vm.selectedService.name))]
                      ),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 mb-20 list-container" },
                        _vm._l(_vm.projectsList, function (project, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "col-xs-12 col-sm-offset-1 col-sm-10 services-list p-0 align-left",
                            },
                            [
                              _c("span", { staticClass: "col-xs-1 p-0" }, [
                                _c(
                                  "span",
                                  { staticClass: "checkbox inline-checkbox" },
                                  [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedProjects,
                                            expression: "selectedProjects",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: project.id,
                                          checked: Array.isArray(
                                            _vm.selectedProjects
                                          )
                                            ? _vm._i(
                                                _vm.selectedProjects,
                                                project.id
                                              ) > -1
                                            : _vm.selectedProjects,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.selectedProjects,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = project.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.selectedProjects =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.selectedProjects = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.selectedProjects = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _c("span", { staticClass: "cr" }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("span", { staticClass: "col-xs-6 p-0" }, [
                                _vm._v(_vm._s(project.name) + " "),
                              ]),
                              _c(
                                "span",
                                { staticClass: "col-xs-5 align-right pr-0" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getExpiryStatus(project.expiresAt)
                                      ) +
                                      " on " +
                                      _vm._s(
                                        _vm._f("dateFilter")(project.expiresAt)
                                      )
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "p",
                        { staticClass: "col-xs-12 disclaimary-text mt-20" },
                        [
                          _vm._v(
                            " Renew to maintain edit access to your project for another year. "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn emergo-blue-button mt-10 mb-10",
                          attrs: { disabled: !_vm.selectedProjects.length },
                          on: {
                            click: function ($event) {
                              return _vm.submitRequest()
                            },
                          },
                        },
                        [_vm._v(" Submit Renewal Request ")]
                      ),
                    ]
                  : [
                      _c("div", { staticClass: "p-confirm" }, [
                        _c("img", {
                          staticClass: "success-img",
                          attrs: {
                            src: "/static/images/icons/endtour_checkbox.svg",
                            alt: "endtour-icon",
                          },
                        }),
                        _c("p", { staticClass: "confirm_title" }, [
                          _vm._v("Success"),
                        ]),
                        _c("div", { staticClass: "mb-10" }, [
                          _vm._v("Thank you for your renewal request."),
                        ]),
                        _c("div", [
                          _vm._v("Our Sales Team will contact you soon."),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn emergo-blue-button mt-25 mb-10 wd-180",
                            on: {
                              click: function ($event) {
                                return _vm.closePopup()
                              },
                            },
                          },
                          [_vm._v(" OK ")]
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }